import { render, staticRenderFns } from "./ResourceimageGallery.vue?vue&type=template&id=2f9172fd&scoped=true"
import script from "./ResourceimageGallery.vue?vue&type=script&lang=ts"
export * from "./ResourceimageGallery.vue?vue&type=script&lang=ts"
import style0 from "./ResourceimageGallery.vue?vue&type=style&index=0&id=2f9172fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9172fd",
  null
  
)

export default component.exports